export default __webpack_public_path__ + "static/media/ruby.775cc228.svg";